import type { ReactElement } from 'react';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'reactstrap';
import HelpLinkButton from 'atom-components/buttons/help-link-button/help-link-button';
import TooltipItem from 'atom-components/tooltip-item';
import { useAuth } from 'services/providers/auth.provider';
import MainMenu from './main-menu';
import UserDropdown from './user-dropdown';
import './sidebar.scss';

type Props = {
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function SidebarCollapsed({ setSidebarOpen }: Props): ReactElement {
  const { me } = useAuth();

  const handleSideBarToggle = (): void => {
    setSidebarOpen((sidebarOpen) => !sidebarOpen);
  };

  return (
    <aside className="sidebar closed">
      <div className="sidebar-header">
        <Button onClick={handleSideBarToggle} color="light" className="sidebar-open w-100 p-2">
          <FontAwesomeIcon icon="angles-right" className="fa-fw" size="lg" />
        </Button>
      </div>
      <div className="sidebar-header">
        <TooltipItem
          id="user"
          tooltip={`${me?.firstname} ${me?.lastname}`}
          tooltipProps={{ placement: 'right' }}
        >
          <UserDropdown isIconOnly />
        </TooltipItem>
      </div>
      <MainMenu expanded={false} />
      <div className="d-flex mx-auto mt-auto h4">
        <HelpLinkButton />
      </div>
    </aside>
  );
}
